import dayjs from 'dayjs';
import { isEmpty, mapValues } from 'lodash';
import * as TimeString from '../TimeString';
export const normalizeList = (intervals) => {
    if (intervals.length === 0) {
        return intervals;
    }
    intervals.sort((a, b) => {
        if (a.open === b.open) {
            return 0;
        }
        return TimeString.toDate(a.open).isAfter(TimeString.toDate(b.open))
            ? 1
            : -1;
    });
    const mergedIntervals = [intervals[0]];
    intervals.forEach((interval) => {
        const currInterval = mergedIntervals[mergedIntervals.length - 1];
        if (TimeString.toDate(currInterval.close).isBefore(TimeString.toDate(interval.open))) {
            mergedIntervals.push(interval);
            return;
        }
        currInterval.close = TimeString.fromDate(dayjs.max(TimeString.toDate(currInterval.close), TimeString.toDate(interval.close)));
    });
    return mergedIntervals;
};
export const mergeNormalizedLists = (a, b) => {
    if (isEmpty(a)) {
        return b;
    }
    if (isEmpty(b)) {
        return a;
    }
    // TODO: separate optimized algo
    return normalizeList([...a, ...b]);
};
export const subtractNormalizedLists = (a, b) => {
    if (isEmpty(b) || a.length === 0) {
        return a;
    }
    const res = [{ ...a[0] }];
    let aIdx = 0;
    for (let bIdx = 0; aIdx < a.length && bIdx < b.length;) {
        const currRes = res[res.length - 1];
        const currResDate = toDatesInterval(currRes);
        const currB = toDatesInterval(b[bIdx]);
        // a    []
        // b []
        if (currResDate.open.isSameOrAfter(currB.close)) {
            ++bIdx;
            continue;
        }
        // a []
        // b    []
        if (currB.open.isSameOrAfter(currResDate.close)) {
            if (++aIdx < a.length) {
                res.push(a[aIdx]);
            }
            continue;
        }
        // a  []
        // b [  ]
        if (currB.open.isSameOrBefore(currResDate.open) &&
            currB.close.isSameOrAfter(currResDate.close)) {
            res.pop();
            if (++aIdx < a.length) {
                res.push(a[aIdx]);
            }
            continue;
        }
        // a [     ]
        // b  [  ]
        if (currB.open.isAfter(currResDate.open) &&
            currB.close.isBefore(currResDate.close)) {
            res.pop();
            res.push({ open: currRes.open, close: b[bIdx].open });
            res.push({ open: b[bIdx].close, close: currRes.close });
            ++bIdx;
            continue;
        }
        // a [  ]
        // b  [  ]
        if (currB.open.isAfter(currResDate.open)) {
            res.pop();
            res.push({ open: currRes.open, close: b[bIdx].open });
            if (++aIdx < a.length) {
                res.push(a[aIdx]);
            }
            continue;
        }
        // a   [  ]
        // b [  ]
        if (currB.close.isBefore(currResDate.close)) {
            res.pop();
            res.push({ open: b[bIdx].close, close: currRes.close });
            ++bIdx;
            continue;
        }
    }
    if (aIdx < a.length) {
        res.push(...a.slice(aIdx + 1));
    }
    return res;
};
const toDatesInterval = (interval) => mapValues(interval, TimeString.toDate);
//# sourceMappingURL=TimeInterval.js.map